import {
  Accordion,
  Badge,
  Button,
  Card,
  Col,
  Container,
  Row,
  Table,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { eventBus } from "../eventBus";
import { paths } from "../types/Defaults";
import ChartImg from "./../images/PortfoliosHomeChart.png";

const FAQsDict = [
  {
    title:
      "How many strategies can produce on average double-digit annual returns?",
    html: (
      <p className="faq-paragraph">
        Not many and this is where we differ from other offers. Explore our
        catalog and analyze the detailed performance data across 10 years of
        market history. Compare to what you currently use and start tracking the
        returns of our systematic model portfolios vs. the benchmark.
      </p>
    ),
  },
  {
    title:
      "Why do our model portfolios outperform many active and passive products?",
    html: (
      <p className="faq-paragraph">
        Because our approach is 100% rule-based and systematic. In our
        experience personal opinions, assumptions and untested methodologies
        often deliver erratic results. We believe in executing hard testing and
        objective validation of the rules governing the selection process across
        a long history covering different market cycles. We like to objectively
        assess and prove where alpha is coming from, and to check all the right
        boxes, that improve the odds to deliver superior performance
        consistently.
      </p>
    ),
  },
  {
    title: "Why are these model portfolios better than most others??",
    html: (
      <p className="faq-paragraph">
        Because they combine two key elements: Careful selection of
        well-validated rules and systematic execution. Our rule-based,
        systematic methodology offers: A Transparent, pragmatic set of
        investment criteria that deliver real alpha. The Possibility to test and
        validate. A flawless, coherent execution. Exclusion of human biases,
        emotions, unproven assumptions and subjective opinions. Rigorous and
        prompt risk control. A smart process to profit from price trends.
      </p>
    ),
  },
  {
    title: "What is the rationale of the selection process?",
    html: (
      <p className="faq-paragraph">
        Our rigorous selection process is checking the two key boxes to perform
        – good growth metrics (sales and earnings) and validated, actual
        positive price trends. This offers the opportunity to exploit the
        performance dispersion across stocks capturing the outperformers that
        show strong uptrends supported by sound fundamentals.
      </p>
    ),
  },
  // {
  //   title: "Why is the turnover high in some strategies?",
  //   html: (
  //     <p className="faq-paragraph">
  //       The market is moving fast and maximizing returns may require prompt,
  //       active management. The turnover is a price to pay if one wants to
  //       achieve superior performance consistently over time.
  //     </p>
  //   ),
  // },
  // {
  //   title: "How many stocks are in a portfolio?",
  //   html: (
  //     <p className="faq-paragraph">
  //       Most portfolios hold 30 stocks. Sometimes the number of stocks selected
  //       can be lower than the maximum number if there are not enough stocks
  //       satisfying the quality rules of the model during a given rebalance
  //       period.
  //     </p>
  //   ),
  // },
  {
    title: "How consistent is the outperformance of the model portfolios?",
    html: (
      <p className="faq-paragraph">
        You can check the number of positive years and quarters in the tables to
        get an idea of the historical consistency in terms of outperformance vs.
        the benchmark.
      </p>
    ),
  },
  {
    title: "What is the difference from other model portfolios?",
    html: (
      <ul>
        <li>
          <p className="faq-paragraph">
            Consistency of superior performance across all the systematic model
            portfolios. The offer from other providers is often a list of
            portfolios with a vast difference in returns over the years. One
            must be lucky to pick the right model portfolio.
          </p>
        </li>
        <li>
          <p className="faq-paragraph">
            Full transparency with a rich set of performance data, including
            yearly, quarterly and monthly statistics and the percentage of
            winning quarters. All this information is not usually available in
            other services. We can offer a detailed disclosure of the numbers as
            we feel strongly about the true value and the consistency of our
            model portfolios across market cycles.
          </p>
        </li>
        <li>
          <p className="faq-paragraph">
            Personal support from our team at no cost. Full assistance with the
            possibility to personalize the portfolios, accommodating different
            goals (fewer stocks, lower turnover and more)
          </p>
        </li>
      </ul>
    ),
  },
  {
    title: "What Is Systematic Investing?",
    html: (
      <p className="faq-paragraph">
        Systematic fund managers use complex quantitative models and data
        analysis to determine portfolio risk exposures. The goal is to introduce
        a higher degree of rigor, testing, transparency, and consistency into
        the investment process, compared to discretionary investing. In
        discretionary investing, decisions often depend on subjective judgment,
        making the rationale behind them difficult to pinpoint and varying over
        time and between decision makers. For example, a discretionary fund’s
        performance can heavily depend on who is managing it at a given time,
        whereas a systematic fund relies primarily on what the data indicates to
        its models at that moment.
      </p>
    ),
  },
  {
    title: "What are the benefits of systematic investing?",
    html: (
      <div>
        <p className="faq-paragraph">
          Here are some of the key benefits of investing in systematic funds, as
          cited by Registered Investment Advisors (RIAs) in recent surveys:
        </p>
        <ul>
          <li>
            <p className="faq-paragraph">
              <strong>Reliability & Repeatability:</strong> Quantitative methods
              intensify the use of data and models, reducing reliance on
              individual biases, preferences, and ad-hoc decision-making.
            </p>
          </li>
          <li>
            <p className="faq-paragraph">
              <strong>Transparency:</strong> While the mathematical operations
              and models behind quantitative methods can be complex, their
              outputs are straightforward and transparent, making investment
              decisions easier to communicate.
            </p>
          </li>
          <li>
            <p className="faq-paragraph">
              <strong>Capital Protection:</strong> Quantitative approaches
              rigorously enforce diversification and capital protection
              mandates, from portfolio construction through to risk exposure
              management and trading operations.
            </p>
          </li>
          <li>
            <p className="faq-paragraph">
              <strong>Risk Management:</strong> Models consistently monitor and
              quantify emerging risks and execute appropriate trades to enhance
              overall risk management.
            </p>
          </li>
        </ul>
      </div>
    ),
  },
];

export function PortfolioHomeClassic() {
  return (
    <>
      <div className="home-header-content--part2b">
        <Container className="pt-4 pb-4">
          <div className="row mt-5">
            <div className="col">
              <p style={{ fontSize: "1.8em" }}>
                Higher investment returns for smart investors going beyond the
                status quo.<br></br>
                <strong>
                  Discover how to maximize the returns from your equity
                  exposure.
                </strong>{" "}
                Learn the enhanced value that a rule-based, systematic
                methodology can deliver. Profit from an advanced investment
                process that consistently beats the conventional, common model
                portfolios.
                <br />
                <strong
                  style={{
                    fontSize: "1.5em",
                    textTransform: "uppercase",
                  }}
                >
                  Our systematic model portfolios are designed to outperform
                  indices and funds across different market cycles.
                </strong>
                <br />
                Our model portfolios deliver consistent outperformance, with
                impressive average annual returns: US ranging from{" "}
                <span style={{ fontWeight: "bold", color: "green" }}>
                  7%
                </span>{" "}
                to{" "}
                <span style={{ fontWeight: "bold", color: "green" }}>11%</span>,
                Europe from{" "}
                <span style={{ fontWeight: "bold", color: "green" }}>12%</span>{" "}
                to{" "}
                <span style={{ fontWeight: "bold", color: "green" }}>18%</span>,
                and Asia from{" "}
                <span style={{ fontWeight: "bold", color: "green" }}>13%</span>{" "}
                to{" "}
                <span style={{ fontWeight: "bold", color: "green" }}>19%</span>.
                It might seem hard to believe, but it’s actually very easy to
                verify.
                <br />
                <ul>
                  <li>
                    Explore the facts! Go to discover our model portfolios.
                  </li>
                  <li>
                    Subscribe for free and gain access to the investment rules
                    and historical holdings.
                  </li>
                  <li>
                    If you want to replicate the model portfolios, subscribe for
                    a flat quarterly license fee, with the option to opt out at
                    any time, and get access to timely rebalancing of the
                    holdings for easy execution.
                  </li>
                </ul>
                There is always a better way to do things. We offer a
                scientific, rule-driven alternative based on fact-finding and
                discipline that easily outperforms traditional investment
                methodologies.
              </p>
            </div>
          </div>
          {/* <Row className="d-flex justify-content-center">
            <Col md={12} style={{ marginTop: "2em" }}>
              <div className="home-section-table neumorphism-container">
                <p
                  style={{
                    fontSize: "1.5em",
                    fontWeight: "bold",
                    textTransform: "uppercase",
                  }}
                >
                  The Trendrating difference – we deliver superior performance
                  with consistency across all the portfolios and across all the
                  years. Examples of systematic model portfolios:
                </p>
                <table className="performance-table">
                  <thead>
                    <tr>
                      <th colSpan={8}>Performance (Annualized Returns)</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th colSpan={2}>1 Year</th>
                      <th colSpan={2}>5 Years</th>
                      <th colSpan={2}>10 Years</th>
                      <th></th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>Absolute</th>
                      <th>vs. Benchmark</th>
                      <th>Absolute</th>
                      <th>vs. Benchmark</th>
                      <th>Absolute</th>
                      <th>vs. Benchmark</th>
                      <th>Sharpe Ratio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>US 30 Growth 8</td>
                      <td>15,64%</td>
                      <td>8,83%</td>
                      <td>29,29%</td>
                      <td>12,51%</td>
                      <td>20,79%</td>
                      <td>10,29%</td>
                      <td>1,26</td>
                    </tr>
                    <tr>
                      <td>EU Growth 7</td>
                      <td>21,98%</td>
                      <td>17,84%</td>
                      <td>34,03%</td>
                      <td>23,25%</td>
                      <td>25,37%</td>
                      <td>22,37%</td>
                      <td>1,38</td>
                    </tr>
                    <tr>
                      <td>Asia 30 Growth 2</td>
                      <td>24,60%</td>
                      <td>21,82%</td>
                      <td>26,18%</td>
                      <td>20,16%</td>
                      <td>17,46%</td>
                      <td>17,31%</td>
                      <td>0,89</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>
          </Row> */}
          <Row className="align-items-md-stretch justify-content-center pb-2">
            <Col
              md={10}
              className="home-header-content-cell text-center mb-5 mt-5"
            >
              <Link
                to={paths.product}
                className="home-button-action button-zoom btn btn-lg mt-3 me-1 btn-primary px-5 fs-3 btn-rounded"
              >
                Discover our Systematic Model Portfolios
              </Link>
            </Col>
          </Row>
        </Container>

        <div className="home-section-1">
          <div className="home-card-text-wrapper">
            <h3>The status quo</h3>
            <p>
              Conventional investment strategies and products underperform the
              indices with alarming consistency. In the mutual funds industry,
              70% of active managers have underperformed their benchmarks across
              all strategies over 3, 5, 7, and 10 years (source: S&P SPIVA
              Scorecard). Similarly, several active ETFs and managed accounts
              fail to deliver reasonable value. This is the outcome of the flaws
              of a discretionary investment process, guided by personal ideas,
              overconfidence, subjective opinions, untested assumptions,
              forecasting traps, and biases.
            </p>
          </div>
          <div className="home-card-image-wrapper"></div>
        </div>

        <div className="home-section-2">
          <div className="home-card-image-wrapper"></div>
          <div className="home-card-text-wrapper" style={{ padding: "2em" }}>
            <h3>The smart alternative</h3>
            <p>
              Systematic investment methodologies can deliver the value that
              investors expect and deserve. An efficient, logical, and pragmatic
              approach based on fact-finding and proven evidence. There is a
              better way to invest in the stock markets. A well-designed
              rule-based, systematic methodology offers higher returns, superior
              risk control, transparency of the rules governing the process, the
              ability to run a rigorous historical test, and to validate the
              results with statistical evidence. All this is supported by
              coherent execution with no deviations. Computer-driven strategies
              avoid the drawback of human mistakes, as they work on a clear,
              well-validated set of pre-defined selection rules, followed with
              discipline. Systematic strategies outperform the discretionary
              approach thanks to the controlled scientific methodology of
              rule-based investing.
            </p>
          </div>
        </div>

        <Container className="pt-4 pb-4">
          <Row className="d-flex justify-content-center">
            <Col md={12}>
              {/* <h3 className="d-flex home-subtitles-m">
                <span className="home-first-impression-big-margin flex-grow-1 flex-shrink-1">
                  <strong style={{ textTransform: "uppercase" }}> */}
              <h2 className="fw-bold mb-3" style={{ textAlign: "center" }}>
                Systematic investment methodologies can deliver the value that
                investors expect and deserve.
              </h2>
              {/* </strong>
                </span>
              </h3> */}

              {/* <div className="advantage-box">
                <div>
                  <p>
                    There is a better way to invest in the stock markets. A
                    well-designed systematic methodology offers better returns,
                    superior risk control, transparency of the rules governing
                    the process, the ability to run a rigorous historical test,
                    and to validate the results with statistical evidence e. All
                    this is based on coherent execution with no deviations.
                    Computer-driven strategies avoid the drawback of human
                    mistakes, as they work on a clear, well-validated set of
                    pre-defined selection rules, followed with discipline.
                    Systematic strategies outperform the discretionary approach
                    thanks to the controlled scientific methodology of
                    rule-based investing.
                  </p>
                </div>
              </div> */}
            </Col>
          </Row>
        </Container>
        <Container fluid className="pt-4 pb-4 black-home-section mt-4">
          <Container>
            <Row className="d-flex justify-content-center">
              <Col md={12}>
                <h3 className="d-flex home-title-m">
                  Why does a systematic methodology work better?
                </h3>
                <p className="black-home-text">
                  The key is in the discovery process and the execution. The
                  analysis of the actual outcomes for any investment rule across
                  historical windows makes the decision process well-informed
                  and sound. An extensive and rigorous testing procedure enables
                  the discovery of the selection rules that best capture alpha.
                  Fact-finding as opposed to unproven assumptions. The next step
                  is exploring different combinations of rules and finding the
                  best-performing mix, usually incorporating good fundamentals
                  and strong price trends. A systematic execution without
                  deviations guarantees a coherent application.
                </p>
              </Col>
              <Col md={12} className="my-5">
                <div
                  className="neumorphism-container d-flex"
                  style={{ color: "black", gap: "1.5em" }}
                >
                  <div style={{ flex: 1 }}>
                    <h3 className="d-flex home-title-m">
                      Our Systematic Model Portfolios
                    </h3>
                    <p
                      className="black-home-text"
                      style={{ fontSize: "1.2em" }}
                    >
                      We offer a new paradigm of value for smart investors that
                      understand it is time to go beyond the status quo. The
                      strategies are designed to deliver superior performance,
                      well above the indices, with consistency over the years.
                      Our service provides a clever alternative to many mediocre
                      products and services. Computer-driven strategies avoid
                      the drawbacks of human mistakes. Our Systematic Model
                      Portfolios are built following a logical sequence of
                      fact-finding and disciplined execution:
                      <ul className="mt-4">
                        <li>
                          Extensive test of different selection parameters to
                          unveil the ones producing most alpha.
                        </li>
                        <li>
                          Comparative analysis of alternative combinations of
                          the best parameters and discovery of the winning
                          sequence, based on sound fundamentals and positive
                          trend validation.
                        </li>
                        <li>
                          Rigorous historical test to validate and document the
                          value and the consistency of the strategy across
                          market cycles.
                        </li>
                      </ul>
                    </p>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      border: "1px solid black",
                      padding: "2em",
                      borderRadius: "25px",
                      background: "black",
                      color: "white",
                    }}
                  >
                    <h3
                      className="d-flex home-title-s"
                      style={{ fontSize: "1.4em" }}
                    >
                      See the Facts
                    </h3>
                    <p
                      className="black-home-text"
                      style={{ fontSize: "1.2em" }}
                    >
                      Check the performance of our systematic model portfolios,
                      easy to track and replicate. Here is a US selection:
                    </p>
                    <img
                      alt={"fact-performances-chart"}
                      src={ChartImg}
                      style={{
                        maxWidth: "100%",
                        height: "auto",
                        objectFit: "contain",
                        width: "100%",
                      }}
                    />
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Link
                        to={paths.product}
                        className="home-button-action button-zoom btn btn-lg mt-3 me-1 btn-primary fs-3 btn-rounded"
                      >
                        Discover our Systematic Model Portfolios
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <ContactUsCallToAction
              handleBtnClick={() =>
                eventBus.dispatch("show-user-subscribe-box", true)
              }
            />
            <PerformanceTable2022 />
          </Container>
        </Container>
        <CompoundedImpactSection />
        <Container className="pt-4 pb-4">
          <Row className="mt-4">
            <Col md={12}>
              {/* <h3 className="d-flex home-subtitles-m">
                <span className="home-first-impression-big-margin flex-grow-1 flex-shrink-1">
                  <strong>The Cost</strong>
                </span>
              </h3> */}
              <h2 className="fw-bold mb-3" style={{ textAlign: "center" }}>
                The Cost
              </h2>
              <div className="advantage-box">
                <p>
                  We do not charge management fees, but just a small
                  subscription fee with opting out at any time. The license fee
                  to access our service is fixed and not related to the assets
                  size, providing full scalability and big cost savings.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {/* <h3 className="d-flex home-subtitles-m">
                <span className="home-first-impression-big-margin flex-grow-1 flex-shrink-1">
                  <strong>The execution</strong>
                </span>
              </h3> */}

              <h2 className="fw-bold mb-3" style={{ textAlign: "center" }}>
                The Execution
              </h2>

              <div className="advantage-box">
                <p>
                  All the model portfolios select only large-cap stocks with
                  high liquidity. Some portfolios require rebalancing at the end
                  of the month, others at the end of the quarter. The
                  replication of the portfolios is therefore very easy and fast
                  to execute.
                </p>
              </div>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center mt-4">
            <Col md={12}>
              {/* <h3 className="d-flex home-subtitles-m">
                <span className="home-first-impression-big-margin flex-grow-1 flex-shrink-1">
                  <strong>ADVANTAGES</strong>
                </span>
              </h3> */}

              <h2 className="fw-bold mb-3" style={{ textAlign: "center" }}>
                ADVANTAGES
              </h2>

              <div className="advantage-box">
                <div>
                  <p>
                    <strong>Generate higher returns.</strong> If you want to get
                    more from your listed equities exposure consider our
                    systematic model portfolios. Go to the catalogue and analyse
                    the performance across years. Compare to what you currently
                    have and decide.
                  </p>
                  <p>
                    <strong>Save on the fees.</strong> Stop paying rich fees for
                    average products and managed accounts.
                  </p>
                  <p>
                    <strong>
                      Get a more robust, consistent portfolio management.
                    </strong>{" "}
                    Our systematic approach guarantees active strategies based
                    on well-defined rules and extensive validation via massive
                    testing. Avoid the uncertain quality of investment decisions
                    based on a discretionary, subjective approach, that can
                    produce inconsistent results.
                  </p>
                  <p>
                    <strong>Gain full transparency.</strong> Use our model
                    portfolios to get total transparency on the holdings and
                    gain extra quality control for your portfolio.
                  </p>
                  <p>
                    <strong>Easy execution.</strong> The model portfolios
                    require a simple rebalancing at the end of the
                    month/quarter.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid className="pt-4 pb-4 black-home-section mt-4">
          <Container>
            <Row className="d-flex justify-content-center mt-5">
              <Col md={12}>
                <h3
                  className="d-flex home-title-m"
                  style={{ justifyContent: "center" }}
                >
                  <span>Transparency</span>
                </h3>
                <p className="black-home-text">
                  Credibility is based on transparency and evidence. We offer
                  full transparency and complete information on:
                  <ul className="mt-4">
                    <li>
                      The selection and allocation rules governing the
                      investment strategies of any model portfolio.
                    </li>
                    <li>
                      The historical performance across the years, with monthly
                      and quarterly data.
                    </li>
                    <li>
                      The holdings in the portfolios at any time in the past.
                    </li>
                  </ul>
                </p>
              </Col>
            </Row>
          </Container>
        </Container>
        <Container className="pt-4 pb-4">
          <Row className="align-items-md-stretch justify-content-center pt-2">
            <Col md={10} className="home-header-content-cell text-center  mt-5">
              <Button
                onClick={() => eventBus.dispatch("show-user-login-box", true)}
                className="home-button-action button-zoom btn btn-lg mt-3 me-1 btn-primary px-5 fs-3 btn-rounded"
              >
                Subscribe to learn more
              </Button>
            </Col>
          </Row>
          <Row className="align-items-md-stretch justify-content-center pb-2 ">
            <Col
              md={10}
              className="home-header-content-cell text-center mb-5 mt-5"
            >
              <Link
                to={paths.product}
                className="home-button-action button-zoom btn btn-lg mt-3 me-1 btn-primary px-5 fs-3 btn-rounded"
              >
                Discover our Systematic Model Portfolios
              </Link>
            </Col>
          </Row>
        </Container>
        <Container className="pt-4 pb-4">
          <Row className="d-flex justify-content-center">
            <Col md={12}>
              <div className="home-section-table neumorphism-container">
                <div className="home-section-table__row">
                  <div style={{ flex: 2 }}></div>
                  <div
                    style={{ flex: 1, fontSize: "1.8em", fontWeight: "bold" }}
                  >
                    Systematic Approach
                  </div>
                  <div
                    style={{ flex: 1, fontSize: "1.8em", fontWeight: "bold" }}
                  >
                    Discretionary Approach
                  </div>
                </div>

                <div className="home-section-table__row">
                  <div style={{ flex: 2 }}>
                    <p>
                      Transparency of the selected investment rules and
                      parameters for selection and allocation.
                    </p>
                  </div>
                  <div style={{ flex: 1, textAlign: "center", color: "green" }}>
                    <i className="bi bi-check-circle-fill"></i>
                  </div>
                  <div style={{ flex: 1, textAlign: "center", color: "red" }}>
                    <i className="bi bi-x-circle-fill"></i>
                  </div>
                </div>

                <div className="home-section-table__row">
                  <div style={{ flex: 2 }}>
                    <p>
                      Coherent, rigorous execution, consistent to the chosen
                      process.
                    </p>
                  </div>
                  <div style={{ flex: 1, textAlign: "center", color: "green" }}>
                    <i className="bi bi-check-circle-fill"></i>
                  </div>
                  <div style={{ flex: 1, textAlign: "center", color: "red" }}>
                    <i className="bi bi-x-circle-fill"></i>
                  </div>
                </div>

                <div className="home-section-table__row">
                  <div style={{ flex: 2 }}>
                    <p>Prompt, disciplined risk control.</p>
                  </div>
                  <div style={{ flex: 1, textAlign: "center", color: "green" }}>
                    <i className="bi bi-check-circle-fill"></i>
                  </div>
                  <div style={{ flex: 1, textAlign: "center", color: "red" }}>
                    <i className="bi bi-x-circle-fill"></i>
                  </div>
                </div>

                <div className="home-section-table__row">
                  <div style={{ flex: 2 }}>
                    <p>
                      Possibility to execute historical tests across market
                      cycles. Hard evidence and rigorous validation.
                    </p>
                  </div>
                  <div style={{ flex: 1, textAlign: "center", color: "green" }}>
                    <i className="bi bi-check-circle-fill"></i>
                  </div>
                  <div style={{ flex: 1, textAlign: "center", color: "red" }}>
                    <i className="bi bi-x-circle-fill"></i>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="d-flex justify-content-center my-5">
            <Col md={12}>
              <h3
                className="d-flex home-title-m"
                style={{ justifySelf: "center" }}
              >
                <span>Free Evaluation</span>
              </h3>
              <p style={{ fontSize: "1.6em" }}>
                Subscribe for free and get access to all the model portfolios.
                Analyze and track the performance. Compare and decide if you
                want to start replicating the ones you like. We charge a flat
                fee with opting out at any time.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="image-page-break">
        <div className="last-section-content">
          <Container>
            <Row className="d-flex justify-content-center">
              <Col md={8}>
                <div className="neumorphism-container">
                  <h3
                    style={{
                      marginBottom: "1.5em",
                      textTransform: "uppercase",
                    }}
                  >
                    How our model Works
                  </h3>
                  <p>
                    We like to execute hard testing and objective validation of
                    the selection process across a long history covering
                    different market cycles. We like to objectively assess and
                    prove where alpha is coming from, and to check all the right
                    boxes, that improve the odds to deliver superior performance
                    consistently. <br />
                    <br />
                    <strong>Our approach is 100% systematic</strong>, with no
                    human interaction and subjective influence. The rules used
                    to select stocks are massively tested across 15 years and
                    are combined and weighted using our algorithmic models.{" "}
                    <strong>Profiting</strong> from the broad performance
                    dispersion across stocks requires a well-tested sequence of
                    selection rules. Our Systematic Model Portfolios select
                    stocks that combine the{" "}
                    <strong>most productive fundamentals</strong> with{" "}
                    <strong>validated price trends</strong>.
                  </p>

                  {/* <ul className="bullet-point-list">
                    <li>
                      The sound <strong>fundamentals</strong> provide the
                      foundation of strong expected returns.
                    </li>
                    <li>
                      The <strong>trend validation</strong> filters out down
                      trends and substantiates the market interest (selecting
                      only good stocks).
                    </li>
                  </ul> */}
                </div>
              </Col>
              <Col md={4}>
                <div className="neumorphism-container">
                  <div className="brand-image"></div>
                </div>
              </Col>
            </Row>
            <Row className="align-items-md-stretch justify-content-center pt-2">
              <Col
                md={10}
                className="home-header-content-cell text-center  mt-5"
              >
                <Button
                  onClick={() => eventBus.dispatch("show-user-login-box", true)}
                  className="home-button-action button-zoom btn btn-lg mt-3 me-1 btn-primary px-5 fs-3 btn-rounded"
                >
                  Subscribe to learn more
                </Button>
              </Col>
            </Row>
            <Row className="align-items-md-stretch justify-content-center pb-2 pt-2">
              <Col
                md={10}
                className="home-header-content-cell text-center mb-5 mt-5"
              >
                <Link
                  to={paths.product}
                  className="home-button-action button-zoom btn btn-lg mt-3 me-1 btn-primary px-5 fs-3 btn-rounded"
                >
                  Discover our Systematic Model Portfolios
                </Link>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <PromoTrialCard
        handleBtnClick={() => eventBus.dispatch("show-user-login-box", true)}
      />
      <div className="image-page-break-last">
        <div className="last-section-content">
          <Container>
            <ContactUsCallToAction
              handleBtnClick={() =>
                eventBus.dispatch("show-user-subscribe-box", true)
              }
            />
            <Row className="d-flex justify-content-center" id={"FAQ"}>
              <Col md={12}>
                <FAQs FAQs={FAQsDict} />
              </Col>
            </Row>
          </Container>
          <Container className="my-5">
            <Row className="align-items-md-stretch justify-content-center pt-2">
              <Col
                md={10}
                className="home-header-content-cell text-center  mt-5"
              >
                <Button
                  onClick={() => eventBus.dispatch("show-user-login-box", true)}
                  className="home-button-action button-zoom btn btn-lg mt-3 me-1 btn-primary px-5 fs-3 btn-rounded"
                >
                  Subscribe to learn more
                </Button>
              </Col>
            </Row>
            <Row className="align-items-md-stretch justify-content-center pb-2 ">
              <Col
                md={10}
                className="home-header-content-cell text-center  mt-5"
              >
                <Link
                  to={paths.product}
                  className="home-button-action button-zoom btn btn-lg mt-3 me-1 btn-primary px-5 fs-3 btn-rounded"
                >
                  Discover our Systematic Model Portfolios
                </Link>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

const FAQ = ({
  question,
  children,
  eKey,
}: {
  question: string;
  children: JSX.Element;
  eKey: string;
}) => {
  return (
    <Accordion.Item eventKey={eKey}>
      <Accordion.Header>
        <h3 className="faq-title">{question}</h3>
      </Accordion.Header>
      <Accordion.Body>{children}</Accordion.Body>
    </Accordion.Item>
  );
};

const FAQs = ({ FAQs }: { FAQs: { title: string; html: JSX.Element }[] }) => {
  return (
    <>
      <h2 className="fw-bold mb-3" style={{ textAlign: "center" }}>
        FAQ
      </h2>
      <Accordion>
        {FAQs.map((f, i) => {
          return (
            <FAQ
              key={i}
              eKey={i.toString()}
              question={f.title}
              children={f.html}
            />
          );
        })}
      </Accordion>
    </>
  );
};

const ContactUsCallToAction = ({
  handleBtnClick,
}: {
  handleBtnClick: () => void;
}) => {
  return (
    <Row className="justify-content-center pb-5">
      <Col md={10} className="text-center mt-5 p-5 fancy-cta">
        <h1
          style={{ fontSize: "1.8vw" }}
          className="display-5 fw-bold text-white mb-4"
        >
          Start replicating our model portfolios to maximize your returns.
        </h1>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "1.5em",
          }}
        >
          <ul>
            <li>
              <h1
                style={{ fontSize: "1.5vw", textAlign: "left" }}
                className="display-5 fw-bold text-white mb-4"
              >
                Use our model portfolios to enhance your equity exposure.
              </h1>
            </li>
            <li>
              <h1
                style={{ fontSize: "1.5vw", textAlign: "left" }}
                className="display-5 fw-bold text-white mb-4"
              >
                See the impact of a small initial allocation and increase it
                over time if you're satisfied.
              </h1>
            </li>
            <li>
              <h1
                style={{ fontSize: "1.5vw", textAlign: "left" }}
                className="display-5 fw-bold text-white mb-4"
              >
                Book a 15-minute call to assess the potential yourself.
              </h1>
            </li>
          </ul>
        </div>
        <p style={{ fontSize: "1.5vw" }} className="display-5  text-white mb-4">
          {" "}
          Once you subscribe, we'll reach out within 24 hours to answer any
          questions and offer you our best deal for full access to the service.
        </p>
        <button
          onClick={handleBtnClick}
          className="btn btn-lg contact-btn px-5 py-3 fs-4 text-white"
        >
          Subscribe
        </button>
      </Col>
    </Row>
  );
};

// export function PromoTrialCard({ handleBtnClick }: any) {
//   const cardStyle: any = {
//     maxWidth: "700px",
//     borderRadius: "20px",
//     border: "none",
//     boxShadow: "0 15px 35px rgba(0,0,0,0.08)",
//     background: "linear-gradient(to bottom right, #ffffff, #fcfdfe)",
//     overflow: "hidden",
//     position: "relative",
//   };

//   return (
//     <Container className="py-5 d-flex justify-content-center">
//       <Card style={cardStyle} className="text-center p-4 p-md-5">
//         <Card.Body>
//           {/* Titolo */}
//           <Card.Title
//             as="h2"
//             className="fw-bold mb-4"
//             style={{ color: "#212529", lineHeight: "1.3" }}
//           >
//             Take advantage of a free trial and seize this opportunity.
//           </Card.Title>

//           {/* Descrizione 1 */}
//           <Card.Text className="text-muted mb-3" style={{ fontSize: "1.1rem" }}>
//             Explore, discover, and evaluate the potential impact for yourself.
//             <br></br>
//             <span className="fw-bold text-dark"> Diversify your exposure.</span>
//           </Card.Text>

//           <hr
//             className="my-4 mx-auto"
//             style={{ width: "50px", opacity: "0.2" }}
//           />

//           {/* Descrizione 2 (Scientific Approach) */}
//           <Card.Text className="fst-italic text-secondary mb-5 px-lg-4">
//             "Experience our scientific management approach with a modest
//             investment and assess for yourself whether it delivers the superior
//             value we claim."
//           </Card.Text>

//           {/* CTA Section */}
//           <div className="d-grid gap-2 col-md-8 mx-auto">
//             <Button
//               variant="primary"
//               size="lg"
//               className="py-3 fw-bold shadow-sm btn-primary"
//               style={{ borderRadius: "12px", transition: "transform 0.2s" }}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.transform = "scale(1.02)")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
//               onClick={handleBtnClick}
//             >
//               Sign up for Immediate Insights
//             </Button>
//           </div>
//         </Card.Body>
//       </Card>
//     </Container>
//   );
// }

export function PromoTrialCard({ handleBtnClick }: any) {
  const cardStyle: any = {
    maxWidth: "85%", // Leggermente più largo per accomodare i punti elenco
    borderRadius: "24px",
    border: "none",
    boxShadow: "0 20px 40px rgba(0,0,0,0.07)",
    background: "linear-gradient(to bottom right, #ffffff, #f8f9fa)",
    overflow: "hidden",
  };

  const featureStyle = {
    fontSize: "0.95rem",
    color: "#495057",
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "1rem",
  };

  return (
    <Container className="py-5 d-flex justify-content-center">
      <Card style={cardStyle} className="p-4 p-md-5">
        <Card.Body>
          {/* Header */}
          <div className="text-center mb-5">
            <Card.Title
              as="h2"
              className="fw-bold mb-3"
              style={{ color: "#1a1e21", lineHeight: "1.2", fontSize: "3rem" }}
            >
              Unlock your free trial today
            </Card.Title>
            <Card.Text
              className="text-muted fs-5"
              style={{ fontSize: "1.5em" }}
            >
              Experience our scientifically-driven investment approach with no
              commitment.
            </Card.Text>
          </div>

          <Row className="m-5">
            <Col lg={12}>
              <p
                className="fw-bold mb-4 text-dark"
                style={{ fontSize: "1.5em" }}
              >
                With your free trial, you’ll get exclusive access to powerful
                tools and insights:
              </p>

              {/* Feature List */}
              <div className="ps-md-3" style={{ fontSize: "1.2em" }}>
                <div style={featureStyle}>
                  <div
                    className="text-primary me-3"
                    style={{ fontSize: "1.2em" }}
                  >
                    ✔
                  </div>
                  <div style={{ fontSize: "1.2em" }}>
                    <strong>Portfolio transparency:</strong> Dive deep into the
                    selection and allocation rules behind each model portfolio’s
                    strategy.
                  </div>
                </div>
                <div style={featureStyle}>
                  <div
                    className="text-primary me-3"
                    style={{ fontSize: "1.2em" }}
                  >
                    ✔
                  </div>
                  <div style={{ fontSize: "1.2em" }}>
                    <strong>Historical performance:</strong> Access detailed
                    monthly and quarterly performance data over the years, so
                    you can make informed decisions.
                  </div>
                </div>
                <div style={featureStyle}>
                  <div
                    className="text-primary me-3"
                    style={{ fontSize: "1.2em" }}
                  >
                    ✔
                  </div>
                  <div style={{ fontSize: "1.2em" }}>
                    <strong>Real-time holdings:</strong> Monitor portfolio
                    holdings at any time, ensuring full transparency and control
                    over your investments.
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Footer & CTA */}
          <div className="text-center">
            <Card.Text className="mb-4 px-lg-5" style={{ fontSize: "1.5em" }}>
              Evaluate, diversify, and discover the potential of your
              investments today, risk-free.
            </Card.Text>

            <div className="d-grid gap-2 col-md-7 mx-auto">
              <div className="d-grid gap-2 col-md-8 mx-auto">
                <Button
                  variant="primary"
                  size="lg"
                  className="py-3 fw-bold shadow-sm btn-primary rounded"
                  style={{ transition: "transform 0.2s" }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "scale(1.02)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                  onClick={handleBtnClick}
                >
                  Subscribe for Immediate Insights
                </Button>
              </div>{" "}
            </div>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}

function PerformanceTable2022() {
  const tableData = [
    { region: "US Large Cap", isHeader: true },
    { name: "US 30 Growth 7", model: -4.84, benchmark: -19.44, diff: 14.6 },
    { name: "US 35 Growth 5", model: -6.18, benchmark: -19.44, diff: 13.26 },
    { name: "US 25 Growth 4 Q", model: -3.68, benchmark: -19.44, diff: 15.76 },
    { name: "US 35 Growth 7 Q", model: -1.74, benchmark: -19.44, diff: 17.7 },
    { region: "EU Large Cap", isHeader: true },
    {
      name: "EU 20 Growth and Value 2",
      model: -4.92,
      benchmark: -12.9,
      diff: 7.98,
    },
    {
      name: "EU 25 Growth and Value 3",
      model: -4.07,
      benchmark: -12.9,
      diff: 8.83,
    },
    {
      name: "EU 30 Growth and Value 1",
      model: -3.03,
      benchmark: -12.9,
      diff: 9.87,
    },
    {
      name: "EU 35 Growth and Value 4 Q",
      model: -6.07,
      benchmark: -12.9,
      diff: 6.83,
    },
  ];

  return (
    <Container className="my-5">
      <Card
        className="shadow-sm border-0"
        style={{ borderRadius: "15px", overflow: "hidden" }}
      >
        <div
          style={{
            height: "6px",
            background: "linear-gradient(90deg, #2a7092, #57a0c4)",
          }}
        ></div>
        <Card.Body className="p-0">
          <div className="p-4" style={{ color: "black" }}>
            <h4 className="fw-bold mb-1">
              Risk Control Comparison – 2022 Analysis
            </h4>
            <p className="text-muted small">
              Systematic Model Portfolio vs Benchmark Comparison
            </p>
          </div>

          <Table responsive hover className="mb-0">
            <thead className="bg-light">
              <tr
                className="text-uppercase small fw-bold"
                style={{ letterSpacing: "0.5px" }}
              >
                <th className="ps-4 py-3">2022 Performance</th>
                <th className="text-center py-3">Systematic Model Portfolio</th>
                <th className="text-center py-3">Benchmark</th>
                <th className="text-center py-3 pe-4">Difference</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) =>
                row.isHeader ? (
                  <tr key={index} className="table-light">
                    <td
                      colSpan={4}
                      className="ps-4 fw-bold py-2 text-primary"
                      style={{ fontSize: "1rem" }}
                    >
                      {row.region}
                    </td>
                  </tr>
                ) : (
                  <tr key={index}>
                    <td
                      className="ps-4 py-3 fw-medium"
                      style={{ fontSize: "1.5rem" }}
                    >
                      {row.name}
                    </td>
                    {/* Font aumentato a 1.1rem e tabular-nums per allineamento perfetto */}
                    <td
                      className="text-center py-3 text-danger"
                      style={{
                        fontSize: "1.5rem",
                        fontVariantNumeric: "tabular-nums",
                      }}
                    >
                      {row.model}%
                    </td>
                    <td
                      className="text-center py-3"
                      style={{
                        fontSize: "1.5rem",
                        fontVariantNumeric: "tabular-nums",
                      }}
                    >
                      {row.benchmark}%
                    </td>
                    <td className="text-center py-3 pe-4">
                      <Badge
                        bg="success"
                        className="px-3 py-2"
                        style={{ borderRadius: "6px", fontSize: "1.05rem" }} // Aumentato font badge
                      >
                        +{row.diff}%
                      </Badge>
                    </td>
                  </tr>
                ),
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
}

function CompoundedImpactSection() {
  const compoundingData = [
    { label: "Base", values: [100, 100, 100] },
    { label: "Year 1", values: [105, 107, 110] },
    { label: "Year 2", values: [110.25, 114.49, 121.0] },
    { label: "Year 3", values: [115.76, 122.5, 133.1] },
    { label: "Year 4", values: [121.55, 131.08, 146.41] },
    { label: "Year 5", values: [127.63, 140.26, 161.05] },
  ];

  return (
    <Container className="py-5">
      {/* --- Intro Text --- */}
      <Row className="mb-5 justify-content-center text-center">
        <Col lg={8}>
          <h2 className="fw-bold mb-3">The Impact</h2>
          <p className="lead text-secondary">
            Our systematic model portfolios can deliver several points above the
            benchmark with consistency across the years.
            <strong>
              {" "}
              Consider the impact of the compounded additional performance over
              time.
            </strong>
          </p>
        </Col>
      </Row>

      {/* --- Compounding Table Card --- */}
      <Card
        className="shadow-lg border-0 mb-5"
        style={{ borderRadius: "20px", overflow: "hidden" }}
      >
        <div
          style={{
            height: "8px",
            background: "linear-gradient(90deg, #2a7092, #57a0c4, #2a7092)",
          }}
        ></div>
        <Card.Body className="p-0">
          <div className="bg-light p-4 text-center border-bottom">
            <h5
              className="text-uppercase fw-bold mb-0"
              style={{ letterSpacing: "1px" }}
            >
              The Compounded Impact of a Return Increase Over Years
            </h5>
          </div>

          <Table responsive borderless className="mb-0 align-middle">
            <thead
              className="text-center"
              style={{
                backgroundColor: "#fcfdfe",
                borderBottom: "1px solid #eee",
              }}
            >
              <tr>
                <th className="py-4 ps-4 text-start text-muted">
                  Additional Performance
                </th>
                <th className="py-4 text-primary">5%</th>
                <th className="py-4 text-primary">7%</th>
                <th className="py-4 text-primary">10%</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {compoundingData.map((row, idx) => (
                <tr
                  key={idx}
                  style={row.label === "Base" ? { color: "#999" } : {}}
                >
                  <td className="py-3 ps-4 text-start fw-bold">{row.label}</td>
                  {row.values.map((val, vIdx) => (
                    <td key={vIdx} className="py-3">
                      {val.toFixed(2)}
                    </td>
                  ))}
                </tr>
              ))}
              <tr
                style={{
                  backgroundColor: "#f8f9fa",
                  borderTop: "2px solid #eee",
                }}
              >
                <td className="py-4 ps-4 text-start fw-bold text-dark">
                  Total Improvement %
                </td>
                <td
                  className="py-4 fw-bold text-success"
                  style={{ fontSize: "1.5rem" }}
                >
                  27.63%
                </td>
                <td
                  className="py-4 fw-bold text-success"
                  style={{ fontSize: "1.5rem" }}
                >
                  40.26%
                </td>
                <td
                  className="py-4 fw-bold text-success"
                  style={{ fontSize: "1.5rem" }}
                >
                  61.05%
                </td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      {/* --- Outro & CTA --- */}
      <Card
        className="border-0 p-4 p-md-5 text-center"
        style={{ backgroundColor: "#f0f4f7", borderRadius: "20px" }}
      >
        <h3 className="fw-bold mb-4">
          Do not miss this opportunity. Go deeper.
        </h3>
        <Row className="justify-content-center mb-4">
          <Col md={10} lg={8}>
            <ul
              className="list-unstyled text-secondary mb-0"
              style={{ fontSize: "1.5rem", lineHeight: "2" }}
            >
              <li>
                <span style={{ color: "green" }}>✓</span> Analyze and test for
                free what we offer.
              </li>
              <li>
                <span style={{ color: "green" }}>✓</span> Compare with the other
                products and services you currently use.
              </li>
              <li>
                <span style={{ color: "green" }}>✓</span> Simulate the potential
                impact on your portfolios and make an informed decision.
              </li>
            </ul>
          </Col>
        </Row>
      </Card>
    </Container>
  );
}
